import React, { FC } from "react";
import WmsAlert from "../react/components/WmsAlert/WmsAlert";
import WmsButton from "../react/components/WmsButton/WmsButton";
import WmsCollapse from "../react/components/WmsCollapse/WmsCollapse";

interface Props {
    onHandleCreateAnotherCharge: () => void;
}

declare const window: any;

const AdjustCustomerChargesAlert: FC<Props> = (props) => {
    const { onHandleCreateAnotherCharge } = props;

    return (
        <div className="adjust-customer-charges-alert-content-container">
            <WmsCollapse
                id="Label_Add_A_Charge"
                headerLabel=""
                showCollapseText={false}
                showCollapseIcon={false}
                className="collapse-wrapper"
            >
                <div className="card-contents">
                    <WmsAlert
                        type="success"
                        title={window.translate("Label_Charge_Submitted_Successfully")}
                        className="success-alert"
                    />
                    <WmsButton
                        buttonType="outlined"
                        wmsSelector="back-button"
                        label={window.translate("Label_Create_Another_Charge")}
                        icon="fa-plus"
                        iconPosition="before"
                        onClickFunc={onHandleCreateAnotherCharge}
                        parentClassName="back-button-wrapper"
                    />
                </div>
            </WmsCollapse>
        </div>
    );
};

export default AdjustCustomerChargesAlert;
